export default "<app-bandwidth-tab [reportSection]=\"reportSection\"></app-bandwidth-tab>";